import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        const pageTitles = {
            "/": "Home - arrangemessage",
            "/ai-demo": "AI Demo Call - arrangemessage",
            "/contact-us": "Contact Us - arrangemessage",
            "/most-searched": "Most Searched - arrangemessage",
            "/account": "Account - arrangemessage",
            "/login": "Login - arrangemessage",
        };

        document.title = pageTitles[location.pathname] || "arrangemessage";
    }, [location.pathname]);

    return null; // This component doesn't render anything
};

export default PageTitleUpdater;
